import { RCAlertBox } from '@reverbdotcom/cadence/components';
import React from 'react';
import I18n from 'i18n-js';
import SpeakerIcon from '@reverbdotcom/cadence/icons/brand/report-orange.svg';

export function StatementPaymentNeededBanner() {
  return (
    <RCAlertBox
      type="error"
    >
      <div className="g-container g-container--cycle d-flex mobile-d-block fx-align-center fx-justify-between">
        <div className="d-flex fx-align-center fx-grow g-col-mobile-12">
          <img
            style={{ width: '5rem' }}
            className='mr-2'
            src={SpeakerIcon}
            alt={I18n.t('discovery.statementPaymentNeededBanner.speakerAlt')}
          />
          <div>
            <h2 className="weight-bold">
              {I18n.t('discovery.statementPaymentNeededBanner.paymentNeededHeadline')}
            </h2>
            <span>
              {I18n.t('discovery.statementPaymentNeededBanner.paymentNeededMessage')}
            </span>
          </div>
        </div>
      </div>
    </RCAlertBox>
  );
}

export default StatementPaymentNeededBanner;
